import * as React from "react";

const PeuIcon: React.FC = () => {
    return (
        <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.90784 15.4471C2.40922 15.4471 2.81568 15.0407 2.81568 14.5393C2.81568 14.0379 2.40922 13.6314 1.90784 13.6314C1.40646 13.6314 1 14.0379 1 14.5393C1 15.0407 1.40646 15.4471 1.90784 15.4471Z"
                stroke="#0E0E0E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.2494 5.7813V14.2187C18.2494 14.4166 18.1422 14.5988 17.9692 14.6949L10.3433 18.9314C10.1788 19.0229 9.97875 19.0229 9.81425 18.9314L2.18839 14.6949C2.01547 14.5988 1.90822 14.4166 1.90822 14.2187L1.9082 5.7813C1.9082 5.58348 2.01546 5.40121 2.18838 5.30514L9.81425 1.06854C9.97875 0.977152 10.1788 0.977152 10.3433 1.06854L17.9692 5.30514C18.1421 5.40121 18.2494 5.58348 18.2494 5.7813Z"
                stroke="#0E0E0E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.3877 5.72736L9.81399 9.85311C9.97849 9.94443 10.1786 9.94443 10.3431 9.85311L17.7952 5.71301"
                stroke="#0E0E0E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.0781 18.1706V10"
                stroke="#0E0E0E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default React.memo(PeuIcon);
